import React, { Component } from 'react';

const tableSort = (key,sortType) => {
    if (sortType == true) {
        return function (a, b) {
            if (a[key] !== null && b[key] !== null) {
                if (a[key].toLowerCase() < b[key].toLowerCase()) return -1;
                if (a[key].toLowerCase() > b[key].toLowerCase()) return 1;
                return 0;
            }

        };
    }

    if (sortType == false) {
        return function (a, b) {
            if (a[key] !== null && b[key] !== null) {
                if (a[key].toLowerCase() > b[key].toLowerCase()) return -1;
                if (a[key].toLowerCase() < b[key].toLowerCase()) return 1;
                return 0;
            }
        };
    }
}

export default tableSort;



// WEBPACK FOOTER //
// ./src/_components/common/Sort/index.js